export const ROUTES = {
  home: '/',
  store: '/store',
  search: '/search',
  user: '/user',
  sentryExamplePage: '/sentry-example-page',
  order: '/order',
  order_wv: '/m',
  storeDetail: (storeId: string) => `/store/${storeId}`,
  orderStore: (storeId: string) => `/order/${storeId}`,
  orderCart: (storeId: string) => `/order/${storeId}/cart`,
  orderStore_wv: (branchId: string) => `/order-wv/${branchId}`,
  orderCart_wv: (branchId: string) => `/order-wv/${branchId}/cart`,
};
